import { Injectable } from '@angular/core';
import { ApplicationInsightsService } from './application-insights.service';

@Injectable({ providedIn: 'root' })
export class LoggerService {
  constructor(private readonly appInsights: ApplicationInsightsService) {}

  info(message: string, properties?: Record<string, string>): void {
    this.appInsights.trackEvent(message, properties);
  }

  warn(message: string, properties?: Record<string, string>): void {
    this.appInsights.trackEvent(`Warning: ${message}`, properties);
  }

  error(message: string, error?: unknown, properties?: Record<string, string>): void {
    const err = error instanceof Error ? error : new Error(message);
    this.appInsights.trackException(err, undefined, properties);
  }
}
